import { Baseurl } from "./url";

// Current British time as reported by the server. Returns the offset (ms) between
// the server and this device's clock so the modal can tick without re-fetching.
export async function getUKTimeOffset() {
    const response = await fetch(`${Baseurl}/time/uk`);
    if (!response.ok) {
        console.error(`HTTP Error: ${response.status}`);
        return null;
    }
    const json = await response.json();
    return new Date(json.datetime).getTime() - Date.now();
}

// Report the time seen on a Hands-On Time clock. No login needed.
// comment is optional free text (at most MAX_COMMENT_LENGTH characters).
// Returns { ok: true, report } or { ok: false, message }.
export const MAX_COMMENT_LENGTH = 500;

// photos (File objects, at most MAX_PHOTOS) are optional; with photos the report is
// sent as a multipart form, without them as JSON.
export async function reportClockTime(placeId, time, comment = '', photos = []) {
    let request;
    if (photos.length > 0) {
        const body = new FormData();
        body.append('time', time);
        body.append('comment', comment);
        photos.forEach((photo) => body.append('photos', photo));
        request = { method: 'POST', body: body }; // the browser adds the multipart boundary
    } else {
        request = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ time: time, comment: comment })
        };
    }
    const response = await fetch(`${Baseurl}/places/${placeId}/clock-reports`, request);
    if (response.ok) {
        return { ok: true, report: await response.json() };
    }
    let message = "Sorry, we couldn't record that. Please try again.";
    try {
        const json = await response.json();
        if (json.message) message = json.message;
    } catch (e) {
        // keep the default message
    }
    console.error(`HTTP Error: ${response.status}`);
    return { ok: false, message };
}

const ukFormat = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
});

export function formatUKTime(ms) {
    return ukFormat.format(new Date(ms));
}
